import { transport } from '@opengov/app-core/transport';
import { useMutation } from '@tanstack/react-query';
import { customReportsQueryKeys } from './customReportsQueryKeys';

type SpreadsheetTableResponse = {
  reference: {
    id: string;
    storyContentId: string;
    spreadsheetId: string;
    namedRangeId: string;
    title: string;
    createdAt: string;
    updatedAt: string;
  };
};

type PutPayload = {
  spreadsheetId: string;
  namedRangeId: string;
  title: string;
};

async function putSpreadsheetTable({
  storyId,
  storyContentId,
  spreadsheetId,
  namedRangeId,
  title
}: PutPayload & { storyId: string; storyContentId: string }): Promise<SpreadsheetTableResponse> {
  return transport
    .url(`/api/stories/v1/stories/${storyId}/content/${storyContentId}/spreadsheet-table`)
    .json({ spreadsheetId, namedRangeId, title })
    .put()
    .json();
}

export function usePutSpreadsheetTable({
  publicationId,
  storyId,
  storyContentId
}: {
  publicationId: string;
  storyId: string;
  storyContentId: string;
}) {
  return useMutation({
    mutationKey: customReportsQueryKeys.putSpreadsheetTable({ publicationId, storyId, storyContentId }),
    mutationFn: (payload: PutPayload) => putSpreadsheetTable({ ...payload, storyId, storyContentId })
  });
}
